import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import SignIn from "./components/SignIn";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
//import LocalLoan from "./components/LocalLoan";
//import Dashboard from "./components/Dashboard";
//import BursaryApplication from "./components/BursaryApplication";
import BursaryAutLogout from "./LogoutTimeOut/BursaryAutLogout";
import DashboardAutoLogout from "./LogoutTimeOut/DashboardAutoLogout";
import LocalLoanAutoLogout from "./LogoutTimeOut/LocalLoanAutoLogout";
import SelectionComponent from "./components/SelectionComponent";
import LocalLoanApproveStep from "./components/LocalLoanApproveStep";
import LoanReport from "./components/LoanReport";
import AbroadScholarship from "./components/StudentAbroadApplication/StudentAbroadScholarship";
import ScholarshipForm from "./components/BursaryPlan/NewScholarshipForm";
import EducationProgramPerScholarship from "./components/StudentAbroadApplication/EducationProgramPerScholarship";
import ScholarshipList from "./components/BursaryPlan/ScholarshipList";
import AddEducationProgram from "./components/BursaryPlan/AddEducationProgram";
import StudentScholarshipApply from "./components/StudentAbroadApplication/StudentScholarshipApply";
import LocalLoanBursaryApplicationUpload from "./components/LocalLoanBursaryApplicationUpload";
import StudentClaimsList from "./components/StudentClaimsList";
import AdminUserManagement from "./components/AdminUserManagement";
import HliAdminAutoLogout from "./LogoutTimeOut/HliAdminAutoLogout";
import HliBursaryApplications from "./components/HliBursaryApplications";
import HliSelectionComponent from "./components/HliSelectionComponent";
import HliUploadStudents from "./components/HliUploadStudents";
import HliGrantedStudents from "./components/HliGrantedStudents";
import HliStudentClaims from "./components/HliStudentClaims";
import ApplicantsList from "./components/BursaryPlan/ApplicantsList";
import EducationProgramApplicants from "./components/BursaryPlan/EducationProgramApplicants";
import EducationProgramApplicantList from "./components/BursaryPlan/EducationProgramApplicantList";
import GrantedStudents from "./components/BursaryPlan/GrantedStudents";
import AbroadSelectionCriteria from "./components/BursaryPlan/AbroadSelectionCriteria";
import AbroadSelectionEvaluationScale from "./components/BursaryPlan/AbroadSelectionEvaluationScale";
import ApplicationAssessment from "./components/BursaryPlan/ApplicationAssessment";
import EvaluatorReport from "./components/BursaryPlan/EvaluatorReport";
import UnevaluatedApplications from "./components/BursaryPlan/UnevaluatedApplications";
import EvaluatorMarkingDetails from "./components/BursaryPlan/EvaluatorMarkingDetails";
import ApplicationEvaluationScores from "./components/BursaryPlan/ApplicationEvaluationScores";
import ProductsPage from "./components/admin/ProductsPage";
import ProductQualificationsPage from "./components/admin/ProductQualificationsPage";
import QualificationsPage from "./components/admin/QualificationsPage";
import InstitutionsPage from "./components/admin/InstitutionsPage";
import CollegesPage from "./components/admin/CollegesPage";
import CampusesPage from "./components/admin/CampusesPage";
import StudyAreasPage from "./components/admin/StudyAreasPage";
import AcademicYearsPage from "./components/admin/AcademicYearsPage";
import CombinationsPage from "./components/admin/CombinationsPage";
import PriorityCoursesPage from "./components/admin/PriorityCoursesPage";
import EducationLevelsPage from "./components/admin/EducationLevelsPage";
import { getDecodedToken, isAuthenticated, getUserRole } from './utils/auth';

/** Administration (reference data) screens — Admin edits, DG has read-only access. */
const ADMIN_ROUTES = [
  { path: "/admin/products", Component: ProductsPage },
  { path: "/admin/product-qualifications", Component: ProductQualificationsPage },
  { path: "/admin/qualifications", Component: QualificationsPage },
  { path: "/admin/institutions", Component: InstitutionsPage },
  { path: "/admin/colleges", Component: CollegesPage },
  { path: "/admin/campuses", Component: CampusesPage },
  { path: "/admin/study-areas", Component: StudyAreasPage },
  { path: "/admin/academic-years", Component: AcademicYearsPage },
  { path: "/admin/combinations", Component: CombinationsPage },
  { path: "/admin/priority-courses", Component: PriorityCoursesPage },
  { path: "/admin/education-levels", Component: EducationLevelsPage },
];

function App() {
  const queryClient = new QueryClient(); // Instance of QueryClient

  //authentication

  const AuthenticationRouter = () => {
    if (!isAuthenticated()) {
      return <Navigate to="/" />;
    }
    
    return <Outlet />;
  };

  const RoleBasedRoute = ({ Component, roles }) => {
    const tokenData = getDecodedToken();
    
    if (!tokenData) {
      return <Navigate to="/" />;
    }
    
    const userRole = tokenData.role;
    return roles.includes(userRole) ? (
      <Component />
    ) : (
      <Navigate to="/" />
    );
  };

  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route element={<AuthenticationRouter />}>
          <Route
            path="/localLoan"
            element={
              <RoleBasedRoute
                Component={LocalLoanAutoLogout}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/busaryapplication"
            element={
              <RoleBasedRoute
                Component={BursaryAutLogout}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route path="/GrantedStudents"
          element={
              <RoleBasedRoute
                Component={GrantedStudents}
                roles={["Admin", "DG"]}
              />
            }
           />
          <Route
            path="/selection"
            element={
              <RoleBasedRoute
                Component={SelectionComponent}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/loanApprovalStep"
            element={
              <RoleBasedRoute
                Component={LocalLoanApproveStep}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              <RoleBasedRoute
                Component={DashboardAutoLogout}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/addScholarship"
            element={
              <RoleBasedRoute
                Component={ScholarshipForm}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/applicantsList"
            element={
              <RoleBasedRoute
                Component={ApplicantsList}
                roles={["SCHOLARSHIP_OWNER","Admin", "DG"]}
              />
            }
          />
          <Route
            path="/studentPortal"
            element={
              <RoleBasedRoute
                Component={AbroadScholarship}
                roles={["User", "DG", "Admin"]}
              />
            }
          />
          <Route
            path="/scholarshipList"
            element={
              <RoleBasedRoute
                Component={ScholarshipList}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/educationProgram_scholarship/:id/:type"
            element={
              <RoleBasedRoute
                Component={EducationProgramPerScholarship}
                roles={["Admin", "DG", "User"]}
              />
            }
          />
          <Route
            path="/educationProgram_scholarship_applicant/:id"
            element={
              <RoleBasedRoute
                Component={EducationProgramApplicants}
                roles={["Admin", "DG","SCHOLARSHIP_OWNER"]}
              />
            }
          />
          <Route
            path="/applicantsListApplicants/:id"
            element={
              <RoleBasedRoute
                Component={EducationProgramApplicantList}
                roles={["Admin", "DG","SCHOLARSHIP_OWNER"]}
              />
            }
          />
          <Route
            path="/abroad-selection-criteria/:programId"
            element={
              <RoleBasedRoute
                Component={AbroadSelectionCriteria}
                roles={["Admin", "DG","SCHOLARSHIP_OWNER"]}
              />
            }
          />
          <Route
            path="/abroad-selection-evaluation-scale/:criteriaId"
            element={
              <RoleBasedRoute
                Component={AbroadSelectionEvaluationScale}
                roles={["Admin", "DG","SCHOLARSHIP_OWNER"]}
              />
            }
          />
          <Route
            path="/assessment/:applicationId/:programId"
            element={
              <RoleBasedRoute
                Component={ApplicationAssessment}
                roles={["Admin", "DG","SCHOLARSHIP_OWNER"]}
              />
            }
          />
          <Route
            path="/evaluator-report"
            element={
              <RoleBasedRoute
                Component={EvaluatorReport}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/evaluator-marking-details/:evaluatorId/:programId"
            element={
              <RoleBasedRoute
                Component={EvaluatorMarkingDetails}
                roles={["Admin", "DG", "SCHOLARSHIP_OWNER"]}
              />
            }
          />
          <Route
            path="/evaluation-scores/:programId"
            element={
              <RoleBasedRoute
                Component={ApplicationEvaluationScores}
                roles={["Admin", "DG", "SCHOLARSHIP_OWNER"]}
              />
            }
          />
          <Route
            path="/unevaluated-applications/:evaluatorId/:programId"
            element={
              <RoleBasedRoute
                Component={UnevaluatedApplications}
                roles={["Admin", "DG", "SCHOLARSHIP_OWNER"]}
              />
            }
          />
          <Route
            path="/add_education_program/:id"
            element={
              <RoleBasedRoute
                Component={AddEducationProgram}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/apply_for_program/:id"
            element={
              <RoleBasedRoute
                Component={StudentScholarshipApply}
                roles={["User", "Admin", "DG"]}
              />
            }
          />
          {/* Add a new route with type as a param */}
          <Route
            path="/apply_for_program/:id/:type"
            element={
              <RoleBasedRoute
                Component={StudentScholarshipApply}
                roles={["User", "Admin", "DG"]}
              />
            }
          />
          <Route
            path="/uploadBursaryApplication"
            element={
              <RoleBasedRoute
                Component={LocalLoanBursaryApplicationUpload}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/studentClaims"
            element={
              <RoleBasedRoute
                Component={StudentClaimsList}
                roles={["Admin", "DG"]}
              />
            }
          />
          <Route
            path="/admin/users"
            element={
              <RoleBasedRoute
                Component={AdminUserManagement}
                roles={["Admin", "DG"]}
              />
            }
          />
          {ADMIN_ROUTES.map(({ path, Component }) => (
            <Route
              key={path}
              path={path}
              element={<RoleBasedRoute Component={Component} roles={["Admin", "DG"]} />}
            />
          ))}
          <Route
            path="/hliAdmin"
            element={
              <RoleBasedRoute
                Component={HliAdminAutoLogout}
                roles={["HLI_ADMIN"]}
              />
            }
          />
          <Route
            path="/hli/bursaryApplications"
            element={
              <RoleBasedRoute
                Component={HliBursaryApplications}
                roles={["HLI_ADMIN"]}
              />
            }
          />
          <Route
            path="/hli/selection"
            element={
              <RoleBasedRoute
                Component={HliSelectionComponent}
                roles={["HLI_ADMIN"]}
              />
            }
          />
          <Route
            path="/hli/uploadStudents"
            element={
              <RoleBasedRoute
                Component={HliUploadStudents}
                roles={["HLI_ADMIN"]}
              />
            }
          />
          <Route
            path="/hli/grantedStudents"
            element={
              <RoleBasedRoute
                Component={HliGrantedStudents}
                roles={["HLI_ADMIN"]}
              />
            }
          />
          <Route
            path="/hli/studentClaims"
            element={
              <RoleBasedRoute
                Component={HliStudentClaims}
                roles={["HLI_ADMIN"]}
              />
            }
          />
          {/* <Route path="/LoanReport" element={<LoanReport />} /> */}
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </QueryClientProvider>
  );
}

export default App;
